import React from 'react'

export const AttachmentIcon = ({ color }: { color?: string }) => {
  const stroke = color || 'currentColor'
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M14.2934 7.36629L8.1667 13.493C7.41613 14.2435 6.39815 14.6652 5.3367 14.6652C4.27524 14.6652 3.25726 14.2435 2.5067 13.493C1.75613 12.7424 1.33447 11.7244 1.33447 10.663C1.33447 9.6015 1.75613 8.58352 2.5067 7.83295L8.63336 1.70629C9.13374 1.20591 9.81239 0.924805 10.52 0.924805C11.2277 0.924805 11.9063 1.20591 12.4067 1.70629C12.9071 2.20666 13.1882 2.88532 13.1882 3.59295C13.1882 4.30059 12.9071 4.97925 12.4067 5.47962L6.27336 11.6063C6.02318 11.8565 5.68385 11.997 5.33003 11.997C4.97621 11.997 4.63688 11.8565 4.3867 11.6063C4.13651 11.3561 3.99596 11.0168 3.99596 10.663C3.99596 10.3091 4.13651 9.96981 4.3867 9.71962L10.0467 4.06629'
        stroke={stroke}
        strokeWidth='1.33333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
